import { render, staticRenderFns } from "./QueryBox.vue?vue&type=template&id=ebf559f2&scoped=true&"
import script from "./QueryBox.vue?vue&type=script&lang=js&"
export * from "./QueryBox.vue?vue&type=script&lang=js&"
import style0 from "./QueryBox.vue?vue&type=style&index=0&id=ebf559f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf559f2",
  null
  
)

export default component.exports